import axios from 'axios'
import i18n from '@/plugins/i18n'

export default {
  // Список
  list (id, page) {
    return axios.get(`${i18n.locale}/api/oopt_highlights/list/${id}?page=${page}`)
  },
  // Данные для формы
  getFormData (id) {
    return axios.get(`${i18n.locale}/api/oopt_highlights/formData/${id}`)
  },
  // создание выдела
  create (id, data) {
    return axios.post(`${i18n.locale}/api/oopt_highlights/create/${id}`, data)
  },
  // Получение данных для редактирования
  getEdit (id) {
    return axios.get(`${i18n.locale}/api/oopt_highlights/get/${id}`)
  }
}
